import api from './api';

class UcaasVerificationService {
    verifyCompany(companyId) {
        return api.post('UcaasVerification/VerifyCompany', {
            companyId
        });
    }

    verifyExternalUser(companyId, userId) {
        return api.post('UcaasVerification/VerifyExternalUser', {
            companyId,
            userId
        });
    }
}

export default new UcaasVerificationService();
